import { useState, useEffect, useContext } from "react";
import { AuthContext } from "../context/AuthContext";

// Custom hook for persistent chat state with user-specific storage
const useChatState = () => {
  const { user } = useContext(AuthContext);
  const userId = user?.id || user?._id || user?.username || 'guest';
  
  // Load current chat from localStorage with user-specific key
  const initialChat = () => {
    const savedChat = localStorage.getItem(`currentChat_${userId}`);
    return savedChat ? JSON.parse(savedChat) : [];
  };

  // Load saved chats from localStorage with user-specific key
  const initialSavedChats = () => {
    const saved = localStorage.getItem(`savedChats_${userId}`);
    return saved ? JSON.parse(saved) : [];
  };

  const [chatHistory, setChatHistory] = useState(initialChat);
  const [savedChats, setSavedChats] = useState(initialSavedChats);
  const [chatInput, setChatInput] = useState("");
  const [processingMessage, setProcessingMessage] = useState(false);
  const [chatConnection, setChatConnection] = useState(true);
  const [activeChatId, setActiveChatId] = useState("current"); // Track which chat is active
  const [saveChatModalOpen, setSaveChatModalOpen] = useState(false);
  const [chatTitle, setChatTitle] = useState("");

  // Save current chat to localStorage whenever it changes
  useEffect(() => {
    if (userId) {
      localStorage.setItem(`currentChat_${userId}`, JSON.stringify(chatHistory));
    }
  }, [chatHistory, userId]);

  // Save all chats to localStorage whenever they change
  useEffect(() => {
    if (userId) {
      localStorage.setItem(`savedChats_${userId}`, JSON.stringify(savedChats));
    }
  }, [savedChats, userId]);

  // Reset or reload chat state when user changes
  useEffect(() => {
    setChatHistory(initialChat());
    setSavedChats(initialSavedChats());
    setActiveChatId("current");
  }, [userId]);

  return {
    chatHistory,
    setChatHistory,
    savedChats,
    setSavedChats,
    chatInput,
    setChatInput,
    processingMessage,
    setProcessingMessage,
    chatConnection,
    setChatConnection,
    activeChatId,
    setActiveChatId,
    saveChatModalOpen,
    setSaveChatModalOpen,
    chatTitle,
    setChatTitle
  };
};

export default useChatState;